export enum ColorsTMS {
  main = 'var(--color-main)',
  main_light = 'var(--color-main-light)',
  main_dark = 'var(--color-main-dark)',
  system_gray = 'var(--color-system-gray)',
  white = 'var(--color-white)',
  bg_gray = 'var(--color-bg-gray)',
  additional_gray = 'var(--color-additional-gray)',
  gray = 'var(--color-gray)',
  gray_dark = 'var(--color-gray-dark)',
  black = 'var(--color-black)',
  btn_text = 'var(--color-btn-text)',
  btn_hover_text = 'var(--color-btn-hover-text)',
  signal_red = 'var(--color-signal-red)',
  signal_green = 'var(--color-signal-green)',
  marker_green = 'var(--color-marker-green)',
}

export enum ColorsLearnIT {
  main = 'var(--color-main)',
  main_light = 'var(--color-main-light)',
  main_dark = 'var(--color-main-dark)',
  system_gray = 'var(--color-system-gray)',
  white = 'var(--color-white)',
  bg_gray = 'var(--color-bg-gray)',
  additional_gray = 'var(--color-additional-gray)',
  gray = 'var(--color-gray)',
  gray_dark = 'var(--color-gray-dark)',
  black = 'var(--color-black)',
  btn_text = 'var(--color-btn-text)',
  btn_hover_text = 'var(--color-btn-hover-text)',
  signal_red = 'var(--color-signal-red)',
  signal_green = 'var(--color-signal-green)',
  marker_green = 'var(--color-marker-green)',
}
